"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DescriptionMessagesPropTypes = exports.DescriptionMessagesDefaultProps = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DescriptionMessagesDefaultProps = {
  description: '',
  descriptionId: '',
  descriptionUniqueId: '',
  errorMessages: [],
  isDescriptionHtml: false,
  isDisabled: false,
  isRadioGroup: false,
  isValid: true
};
exports.DescriptionMessagesDefaultProps = DescriptionMessagesDefaultProps;
var DescriptionMessagesPropTypes = {
  /**
   Optional. Custom description of input group. Can be a string or a React component (object).
   */
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({})]),

  /**
   Optional. Custom ID for description of input group.
   */
  descriptionId: _propTypes.default.string,

  /**
   Optional. descriptionUniqueId passes through to assign the id properly.
   */
  descriptionUniqueId: _propTypes.default.string,

  /**
   Optional. Array of error message strings.
   */
  errorMessages: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   Optional. Used to pass HTML in the description prop. Defaults false.
   */
  isDescriptionHtml: _propTypes.default.bool,

  /**
   Optional. Defaults false.
   */
  isDisabled: _propTypes.default.bool,

  /**
   Optional. Used to render logic specific to the Radio Group.
   */
  isRadioGroup: _propTypes.default.bool,

  /**
   Optional. Defaults true.
   */
  isValid: _propTypes.default.bool
};
exports.DescriptionMessagesPropTypes = DescriptionMessagesPropTypes;